import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';
import './Article.scss'
import { VignetteArticle } from 'react-vignette';
import { GA_VPush } from "../Services/GoogleAnalytics";

export default function Article() {
    // The prop id
    let id = useLocation().pathname.slice(1, useLocation().pathname.length)
    let articleSecRef = useRef()


    useEffect(() => {
        //Spot IM required changes in their attributes
        let spotimScript = document.querySelector("#templemount")
        spotimScript.setAttribute("data-post-url", "https://z.ynet.co.il/short/content/2020/TempleMount/#/" + id)
        spotimScript.setAttribute("data-post-id", id)

        //Scrolls to the top when going to the top
        window.scrollTo(0, 0)

        // Mutation Observer
        // Analitics - Virtual page push
        const config = { attributes: true, childList: true, subTree: true }
        const mutationHandler = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    GA_VPush("הר המריבה - " + document.querySelector("#artiheader h1").textContent, `/templemount/article/${id}`);
                    observer.disconnect();
                    return;
                }
                else if (mutation.type === 'attributes') {
                    console.log('The ' + mutation.attributeName + ' attribute was modified.');
                }
            }
        }

        const observer = new MutationObserver(mutationHandler)

        observer.observe(articleSecRef.current, config)

    }, [])

    useEffect(() => {
        window.addEventListener("load", () => {
            window.setTimeout(() => {
                removeDuplicateVideos();
            }, 500);
            window.setTimeout(() => {
                removeDuplicateVideos();
            }, 1000);
        })
    }, []);

    const removeDuplicateVideos = () => {
        let videoContainer = window.document.querySelector(".flp6ScriptContainer");
        if (videoContainer) {
            let videoID = videoContainer.querySelectorAll("video");
            for (let i = 1; i < videoID.length; i++)
                videoID[i].remove();
        }
    }

    // Article Test id 5756290      @@@@
    return (
        <section className="article_sec">
            <div className="vin_wrapper" ref={articleSecRef}>
                <VignetteArticle articleId={id} />
            </div>
            <div id="spot" data-spotim-module="conversation" data-post-url="ARTICLE_URL" data-article-tags="ARTICLE_TOPIC1, ARTICLE_TOPIC2" data-post-id={`${id}`}></div>
        </section>
    )
}
